import { A11yModule } from '@angular/cdk/a11y';
import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { Router, RouterModule } from '@angular/router';
import { AppRolesDirective } from '@directives/appRoles/app-roles.directive';
import { RolDto } from '@models/seguridad/roles/rolDto.model';
import { SharedModule } from '@modules/shared.module';
import { LoginService } from '@services/login/login.service';
import { NgxSpinnerModule } from 'ngx-spinner';

@Component({
  standalone: true,
  imports: [
    CommonModule, MatMenuModule,MatButtonModule,
    RouterModule,
    MatIconModule,AppRolesDirective],
  selector: 'app-menu-setting',
  templateUrl: './menu-setting.component.html',
  styleUrls: ['./menu-setting.component.css']
})
export class MenuSettingComponent implements OnInit {

  Permisos: string = '';
  rol!: RolDto;
  isEditable: boolean = false

  constructor(
    private router: Router,
    private loginService: LoginService,
  ) { }

  ngOnInit(): void {
  }

  logOut() {
    this.loginService.logout();
  }

}
